/**
 * This is a utility to create a React Component that always:
 *
 * 1. calls some hook
 * 2. renders null
 *
 * This is convenient in some cases where we need to conditionally call a hook, but don't want to
 * refactor existing components to add a space for this to happen.
 *
 * In cases like this, we can create a new component:
 * @example ts
 * const MyCommandRegistrator = createRegistrator(useSomeCommands)
 *
 * <MyCommandRegistrator />
 */
export const createRegistrator =
  <HookOptions extends unknown>(
    useRegisterCommandHook: (options: HookOptions) => void,
  ): React.FC<HookOptions> =>
  (props) => {
    useRegisterCommandHook(props);
    return null;
  };
